<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qACL37/tc-custom/9780814776476.jpg?1726519407737" alt="This image is the cover for the book Race, Ethnicity, and Policing"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Race, Ethnicity, and Policing
      </h1>
      <p class="bookDescription body article font2">
        <p>From Rodney King and “driving while black” to claims of targeting of undocumented Latino immigrants, relationships surrounding race, ethnicity, and the police have faced great challenge. <b>Race, Ethnicity, and Policing</b> includes both classic pieces and original essays that provide the reader with a comprehensive, even-handed sense of the theoretical underpinnings, methodological challenges, and existing research necessary to understand the problems associated with racial and ethnic profiling and police bias. This path-breaking volume affords a holistic approach to the topic, guiding readers through the complexity of these issues, making clear the ecological and political contexts that surround them, and laying the groundwork for future discussions. The seminal and forward-thinking twenty-two essays clearly illustrate that equitable treatment of citizens across racial and ethnic groups by police is one of the most critical components of a successful democracy, and that it is only when agents of social control are viewed as efficient, effective, and legitimate that citizens will comply with the laws that govern their society. The book includes an introduction by Robin S. Engel and contributions from leading scholars including Jeffrey A. Fagan, James J. Fyfe, Bernard E. Harcourt, Delores Jones-Brown, Ramiro Martínez, Jr., Karen F. Parker, Alex R. Piquero, Tom R. Tyler, Jerome H. Skolnick, Ronald Weitzer, and many others.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen K Rice, Michael D White
      </h2>
      
      <p class="authorDescription body article"><B>Stephen K. Rice (Editor) </B><br><B>Stephen K. Rice</B> is Associate Professor in the Department of Criminal Justice at Seattle University. He is lead editor of Race, Ethnicity and Policing: New and Essential Readings. His scholarship has also appeared in outlets to include Criminology, Justice Quarterly, and the Journal of Quantitative Criminology.<br><br><B>Michael D. White (Editor) </B><br><B>Michael D. White</B> is Professor in the School of Criminology and Criminal Justice at Arizona State University and the Associate Director of ASU’s Center for Violence Prevention and Community Safety. He is co-author of <I>Cops, Cameras, and Crisis: The Potential and the Perils of Police Body-Worn Cameras</I> (2020); <I>Stop and Frisk: The Use and Abuse of a Controversial Policing Tactic</I> (2016); and <I>Jammed Up: Bad Cops, Police Misconduct, and the New York City Police Department</I> (2013).<br><br></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?65a1f718